const COURSE_RUN_STATUS_PUBLISHED = 'published';
// note: 'reviewed' actually means 'scheduled' (past PC review and ready for publication on publication date)
const COURSE_RUN_STATUS_REVIEWED = 'reviewed';
const COURSE_RUN_STATUS_UNPUBLISHED = 'unpublished';
const COURSE_RUN_AVAILABILITY_ARCHIVED = 'archived';
const PROGRAM_STATUS_UNPUBLISHED = 'unpublished';

const PRODUCT_CATEGORY_BADGES_MAP = {
  Masters: 'Masters',
  "Master's": "Master's",
  Bachelors: 'Bachelors',
  "Bachelor's": "Bachelor's",
  'Boot Camp': 'Boot Camp',
  'Executive Education': 'Executive Education',
  'Professional Certificate': 'Professional Certificate',
  XSeries: 'XSeries',
  Course: 'Course',
  MicroMasters: 'MicroMasters®',
  MicroBachelors: 'MicroBachelors®',
  Certificate: 'Certificate',
  License: 'License',
  Doctorate: 'Doctorate',
};

const EXPANDED_CARD_LIST = [
  'CS50 Courses',
  'CS50 Programs',
];

const PRODUCT_MAP_2U = {
  BACHELORS: {
    NAME: 'Bachelor\'s',
    DISCOVERY_KEY: 'bachelors',
    PROSPECTUS_KEY: 'bachelors',
  },
  BOOT_CAMP: {
    NAME: 'Boot Camp',
    DISCOVERY_KEY: 'bootcamp-2u',
    PROSPECTUS_KEY: 'bootCamps',
  },
  EXECUTIVE_EDUCATION: {
    NAME: 'Executive Education',
    DISCOVERY_KEY: 'executive-education-2u',
    PROSPECTUS_KEY: 'executiveEducation',
  },
  MASTERS: {
    NAME: 'Master\'s',
    DISCOVERY_KEY: 'masters',
    PROSPECTUS_KEY: 'masters',
  },
  DOCTORATE: {
    NAME: 'Doctorate',
    DISCOVERY_KEY: 'doctorate',
    PROSPECTUS_KEY: 'doctorate',
  },
  LICENSE: {
    NAME: 'License',
    DISCOVERY_KEY: 'license',
    PROSPECTUS_KEY: 'license',
  },
  CERTIFICATE: {
    NAME: 'Certificate',
    DISCOVERY_KEY: 'certificate',
    PROSPECTUS_KEY: 'certificate',
  },
};

const PRODUCT_MAP_EDX = {
  PROFESSIONAL_CERTIFICATE: {
    NAME: 'Professional Certificate',
    DISCOVERY_KEY: 'professional-certificate',
    PROSPECTUS_KEY: 'professionalCertificate',
  },
  MASTERS: {
    NAME: 'Master\'s',
    DISCOVERY_KEY: 'masters',
    PROSPECTUS_KEY: 'masters',
  },
  MICRO_MASTERS: {
    NAME: 'MicroMasters',
    DISCOVERY_KEY: 'micromasters',
    PROSPECTUS_KEY: 'microMasters',
  },
  MICRO_BACHELORS: {
    NAME: 'MicroBachelors',
    DISCOVERY_KEY: 'microbachelors',
    PROSPECTUS_KEY: 'microBachelors',
  },
  COURSE: {
    NAME: 'Course',
    DISCOVERY_KEY: 'verified-audit',
    PROSPECTUS_KEY: 'course',
  },
  XSERIES: {
    NAME: 'XSeries',
    DISCOVERY_KEY: 'xseries',
    PROSPECTUS_KEY: 'xSeries',
  },
};

const EXEC_ED_TYPE = {
  SHORT_COURSE: 'short_course',
  SPRINT: 'sprint',
};

const EXTERNAL_PRODUCT_SOURCES = {
  EMERITUS: 'emeritus',
  SHORELIGHT: 'shorelight',
};
const EXTERNAL_PRODUCT_SOURCE_SLUGS = Object.values(EXTERNAL_PRODUCT_SOURCES);

const PRODUCT_STATUSES = {
  ARCHIVED: 'archived',
  PUBLISHED: 'published',
};

module.exports = {
  PRODUCT_CATEGORY_BADGES_MAP,
  COURSE_RUN_AVAILABILITY_ARCHIVED,
  COURSE_RUN_STATUS_PUBLISHED,
  COURSE_RUN_STATUS_REVIEWED,
  COURSE_RUN_STATUS_UNPUBLISHED,
  PRODUCT_MAP_2U,
  PRODUCT_MAP_EDX,
  PROGRAM_STATUS_UNPUBLISHED,
  EXPANDED_CARD_LIST,
  EXTERNAL_PRODUCT_SOURCES,
  EXTERNAL_PRODUCT_SOURCE_SLUGS,
  PRODUCT_STATUSES,
  EXEC_ED_TYPE,
};
